import styled from "styled-components"
import { useSignal, computed } from "@preact/signals"
import { useEffect } from "preact/compat"

// 计时器容器的样式
const TimerBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    font-family: "Gilroy";
    font-weight: 700;
`

// 时分秒数字的样式
const Hms = styled.span`
    font-family: "Gilroy";
    font-size: 12rem;
    font-weight: 700;
    color: #fff;
    width: 24rem;
    height: 16rem;
    border-radius: 2rem;
    background-color: #fff;
    color: #f53364;
    text-align: center;
    line-height: 17rem;
`

/**
 * 计时器组件的 Props 类型
 * @param {number} [time] - 初始时间（单位：秒），默认为 0。
 * @param {Function} [onTimeEnd] - 倒计时结束的回调函数。
 */
type TimerProps = {
    time?: number
    onTimeEnd: () => void
}

const Timer: React.FC<TimerProps> = ({ time, onTimeEnd }) => {
    // 使用信号管理当前时间（秒）
    const currentTime = useSignal(time ?? 0)

    // 计算属性：小时、分钟和秒
    const hours = computed(() => Math.floor(currentTime.value / 3600))
    const minutes = computed(() => Math.floor((currentTime.value % 3600) / 60))
    const seconds = computed(() => currentTime.value % 60)

    // 副作用：每秒减少时间
    useEffect(() => {
        let interval: NodeJS.Timeout | null = setTimeout(() => {
            if (currentTime.value > 0) {
                currentTime.value--
            } else {
                onTimeEnd()
                if (interval) {
                    clearTimeout(interval)
                    interval = null
                }
            }
        }, 1000)

        // 清理函数：清除定时器
        return () => {
            if (interval) {
                clearTimeout(interval)
                interval = null
            }
        }
    }, [currentTime.value, onTimeEnd])

    return (
        <TimerBox>
            <Hms>{hours.value.toString().padStart(2, "0")}</Hms>:
            <Hms>{minutes.value.toString().padStart(2, "0")}</Hms>:
            <Hms>{seconds.value.toString().padStart(2, "0")}</Hms>
        </TimerBox>
    )
}

export default Timer
